import m from "../../geodata/es2015/austriaHigh";
window.am4geodata_austriaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/austriaHigh.js
// module id = null
// module chunks = 